import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, Signal } from '@angular/core'
import { Router } from '@angular/router';
import { BadgeStatusComponent } from '@components/badge-status/badge-status.component';
import { ButtonComponent } from '@components/button/button.component';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';
import { LinkComponent } from '@components/link/link.component';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { Sale, saleItem } from 'app/interfaces/sale.interface';
import { AnalyticsService } from 'app/services/analytics.service';
import { ApiService, UserInfo } from 'app/services/api.service'
import { SalesService } from 'app/services/sales.service';
import { SalesforceService } from '../../../services/salesforce.service'
import { SlickCarouselModule } from 'ngx-slick-carousel'

@Component({
    selector: 'app-sales-list-item',
    standalone: true,
    templateUrl: './sales-list-item.component.html',
    styleUrl: './sales-list-item.component.scss',
    imports: [CommonModule, BadgeStatusComponent, TranslateModule, LinkComponent, ButtonComponent, ConfirmModalComponent, SlickCarouselModule, CosentinoSvgComponent],
})
export class SalesListItemComponent implements OnInit {
    @Input() sale: Sale
    @Input() userInfo: Signal<UserInfo>
    @Output() onDelete: EventEmitter<void> = new EventEmitter<void>();
    public saleActions!: any
    public isConfirmModalVisible: boolean = false
    applicationLabel: string;

    ACTIOS_CUT_OFF_DAYS = SalesService.ACTIOS_CUT_OFF_DAYS;

    slideConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        dotsClass: 'slick-dots-we',
        nextArrow:
            '<svg style="position:absolute;top:42%;right:0;z-index:10;cursor:pointer;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z" fill="#232323"/></path></svg>',
        prevArrow:
            '<svg style="position:absolute;top:42%;z-index:10;cursor:pointer;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.0002 17.3L8.7002 12L14.0002 6.69995L14.7002 7.39995L10.1002 12L14.7002 16.6L14.0002 17.3Z" fill="#232323"/></path></svg>',
    };

    constructor(
        private salesService: SalesService,
        private router: Router,
        private api: ApiService,
        private analytics: AnalyticsService,
        private translate: TranslateService,
        private salesforce: SalesforceService
    ) {}

    ngOnInit(): void {
        this.saleActions = this.salesService.getSaleActions(this.sale, this.userInfo())
        this.setApplicationLabel()
    }

    setApplicationLabel() {
        if(this.sale?.saleItems?.[0]?.applicationTypeLabel){
            const translation: string = this.translate.instant('my_sales.applications.' + this.sale.saleItems[0].applicationTypeLabel)
            if(translation && !translation.includes('my_sales.applications.')) {
                this.applicationLabel = translation
            } else {
                this.applicationLabel = this.sale.saleItems[0].applicationTypeLabel
            }
        } else {
            this.applicationLabel = ''
        }
    }

    getItemApplicationLabel(item: saleItem): string {
        if (item?.applicationTypeLabel) {
            const translation: string = this.translate.instant('my_sales.applications.' + item.applicationTypeLabel)
            if (translation && !translation.includes('my_sales.applications.')) {
                return translation
            }
            return item.applicationTypeLabel
        }
        return ''
    }

    public removeSale(saleId: string): void {
        // Implement the logic to remove the sale
        console.log(`Removing sale with ID: ${saleId}`)
         this.api.deleteSale(saleId).subscribe({
             next: () => {
                 this.isConfirmModalVisible = false
                  this.onDelete.emit();
             },
             error: (err) => {
                 console.error('Error deleting sale', err)
                 // opcional: mostrar error y mantener modal abierto
             },
         })
    }

    public sendInstructions(saleId: string): void {
        // Implement the logic to send instructions for the sale
        console.log(`Sending instructions for sale with ID: ${saleId}`)
    }

    public updateCustomerName(data: any) {
        console.log(data)
        this.salesService.updateCustomerName(this.sale.id, data.target.value).subscribe()
    }

    public handleClick(operation: string) {
        console.log(`Operation: ${operation}`)
        if (operation === 'downloadWarranty') {
            this.getDocument()
            return
        }

        if (operation === 'removeSale') {
            // Mostramos modal para confirmar operación
            this.isConfirmModalVisible = true
            // Scroll into view for salesforce
            this.salesforce.resize(600)
            return
        }

        if (operation === 'activateWarranty') {
            this.analytics.trackCustom('new_sale', {
                flow_name: 'new-sale',
                form_option: 'activate-warranty',
                form_option1: 'not-available',
                form_option2: 'not-available',
                step: 'step3_how-to-activate-warranty'
            });

            this.router.navigate(['new-sales', this.sale.id, 'activate']);
            return;
        }

        if (operation === 'sendInstructions') {
            this.analytics.trackCustom('new_sale', {
                flow_name: 'new-sale',
                form_option: 'send-instructions',
                form_option1: 'not-available',
                form_option2: 'not-available',
                step: 'step3_how-to-activate-warranty'
            });

            this.router.navigate(['new-sales', this.sale.id, 'instructions']);
            return;
        }


        if (operation === 'completeSale') this.router.navigate(['new-sales', this.sale.id])
    }


    getDocument = () => {
        this.salesService.downloadWarranty(this.sale.id, this.sale.warrantyNumber as string).subscribe((blob) => {
            const blobUrl = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = blobUrl
            a.download = 'warranty' + '_' + this.sale.warrantyNumber + '.pdf'
            a.click()

            // Limpieza
            window.URL.revokeObjectURL(blobUrl)
        })
    }
}
